module.exports = __webpack_public_path__ + "img/charak_katan_yes.02e42cc3.png";